<template>
  <div class="section section_blue">
    <div class="max-width">
      <div class="banner">
        <div class="banner__grid">
          <div class="banner__about">
            <h2 class="section__title">{{ title }}</h2>
            <div class="section__text">{{ text }}</div>
            <div class="section__buttons">
              <a :href="purchaseLink" class="button" target="_blank">
                Purchase Now
                <span>{{ price }}</span>
              </a>
              <a :href="previewLink" class="button button_border" target="_blank">
                Live Preview
                <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 25 24">
                  <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                    <path d="M12.023 7.625a4.375 4.375 0 1 0 0 8.75a4.375 4.375 0 0 0 0-8.75M9.148 12a2.875 2.875 0 1 1 5.75 0a2.875 2.875 0 0 1-5.75 0"/>
                    <path d="M12.023 4.5c-4.312 0-8.025 2.556-9.722 6.235a3.02 3.02 0 0 0 0 2.53c1.697 3.679 5.41 6.235 9.722 6.235s8.026-2.556 9.723-6.235c.37-.802.37-1.728 0-2.53c-1.697-3.679-5.41-6.235-9.723-6.235m-8.36 6.863C5.125 8.194 8.32 6 12.023 6c3.704 0 6.899 2.194 8.36 5.363c.187.404.187.87 0 1.274C18.923 15.806 15.728 18 12.024 18s-6.898-2.194-8.36-5.363a1.52 1.52 0 0 1 0-1.274"/>
                  </g>
                </svg>
              </a>
            </div>
          </div>

          <div class="banner__pic">
            <div class="banner__slider">
              <div class="scroll-banner">
                <div class="scroll-banner__track">
                  <img loading="lazy" :src="imgMain" :srcset="imgSet" alt="">
                  <img loading="lazy" :src="imgMain" :srcset="imgSet" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerView',
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
    purchaseLink: { type: String, required: true },
    previewLink: { type: String, required: true },
    price: { type: String, required: false, default: '$0' },
    imgMain: { type: String, required: true },
    imgSet: { type: String, required: true }
  }
}
</script>

<style lang="scss">
.banner {
  @include md {
    overflow:hidden;
    margin:0 -1.25rem;
    padding:0 1.25rem;
  }

  &__grid {
    display:flex;
    gap:2rem;
    align-items:center;

    @include md {
      flex-direction:column;
      gap:3rem;
    }
  }

  &__about {
    flex:auto;

    @include xs {
      text-align:center;
    }

    .section__title {
      font-size:2.5rem;

      @include xs {
        font-size:2rem;
      }
    }

    .section__text {
      max-width:514px;
    }

    .section__buttons {
      flex-wrap:wrap;

      @include xs {
        justify-content:center;
      }

      .button {
        @include xs {
          padding:0;
          flex:auto;
        }

        &_border {
          gap:6px;

          svg {
            width:22px;
            height:auto;
          }
        }
      }
    }
  }

  &__pic {
    flex:none;
    width:49%;
    aspect-ratio: 1;
    display:flex;
    align-items:center;
    justify-content:flex-end;
    background:#fff;
    border-radius:12px;
    overflow:hidden;

    @include md {
      width:initial;
      aspect-ratio: initial;
      border-radius:0;
      background:none;
      margin:0 -3rem;
    }

    @include xs {
      margin:0 -1.25rem;
    }
  }

  &__slider {
    width:100%;

    .scroll-banner {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: auto;
      --image-width: 3013px;
      --scroll-speed:40s;
      padding:3rem 0;
      margin:-3rem 0;

      @include xs {
        --image-width: 1800px;
      }

      &__track {
        display: flex;
        width: calc(var(--image-width) * 2);
        animation: scroll-x linear infinite;
        animation-duration: var(--scroll-speed);
        gap:1.5rem;

        img {
          width: var(--image-width);
          height: auto;
          flex-shrink: 0;
          object-fit: cover;
          -webkit-user-drag: none;
          user-select: none;
          pointer-events: none;
        }
      }
    }

    @keyframes scroll-x {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(calc(-50% - 1.5rem));
      }
    }
  }
}
</style>
